import React, { Component, useState } from "react";
import CryptoJS from "crypto-js";
import { assessmentActions, questionsActions, userActions } from "../../../_actions";
import { connect } from "react-redux";
import Summary from "./Summary/Summary";
import SummaryRTL from "./SummaryRTL/Summary";

import ExpertScreen from "./Summary/ExpertScreen";
import QuestionHeader from "../Component/QuestionHeader";
import LogoAssessmentHeader from "../Component/LogoAssessmentHeader";
import LogoAssessmentSummaryHeader from "../Component/LogoAssessmentSummaryHeader";
import FeedbackModal from "./FeedbackModal";
import AssessmentReportSchool from "../Component/AssessmentReportSchool/AssessmentReportSchool";
import AssessmentReport from "../Component/AssessmentReport/AssessmentReport";
import AssessmentSummary from "../Component/AssessmentSummary/AssessmentSummary";
import AssessmentTop5Summary from "../Component/AssessmentTop5Summary/AssessmentTop5Summary";
import AssessmentManagerReport from "../Component/AssessmentManagerReport/AssessmentManagerReport";
import AssessmentHiringReport from "../Component/AssessmentHiringReport/AssessmentHiringReport";
import VideoFrameModal from "./Summary/VideoFrameModal/VideoFrameModal";
import VideoCourse from "./VideoCourse/VideoCourse";
import { MdArrowForwardIos } from "react-icons/md";
import moment from "moment";
import Survey from "./Survey";
import SurveyRTL from "./SurveyRTL";
import DashboardUser from "../../AdminPanel/Dashboard/DashboardUser";
import Heading from "../../AdminPanel/Component/UI/ViewButton";
import ViewButton from "../../AdminPanel/Component/UI/ViewButton";
import TriangleChart from "./Charts/TriangleChart";
import { MdOutlineStarOutline } from "react-icons/md";
import { HiOutlineBriefcase } from "react-icons/hi";
import { BsLightningCharge } from "react-icons/bs";


class QuestionPublish extends Component {
  constructor(props) {
    super(props);
    this.state = {
      top5Talent: false,
      isDisableSubmit: false,
      SurveyCode: this.props.codeValue,
      routeMenu: "Summary",
      radioButton: false,
      radioButton2: false,
      currQues: null,
      showWelcomeScreen: true,
      showQuestionScreen: false,
      showThankyouScreen: false,
      instructionPage: false,
      showRedFlag: false,
      saveMsg: "",
      CurrQuesIndex: 1,
      submitSucces: false,

      surveyLanguageName: "English",
      ShowSubmitButton: false,

      textAnswer: "",
      unattemptList: [],
      changeType: "fade",
      mandatoryOn: false,
      afterSubmitData: {
        thankyouText: "",
        bgColor: "",
        bgImage: "",
        textcolor: "",
        logo: "",
      },
      alreadySubmitted: false,
      clicked: false,

      showDropdownQues: false,
      dropdownInput: "",
      scrollPosition: 0,
      IpObj: {},
      ShowNotAttempted: false,
      submitMandatory: "",
      setTimeoutRef: "",
      setTimeoutInit: 0,
      disableTimer: false,
      timeCounter: 0,
      setIntervalRef: "",
      showReportModal: false,
      showSummaryReport: false,
      showManagerReportModal: false,
      showHiringReport: false,

      showViewReportThankYouButton: false,
      surveyLanguageCode: "",

      themeType: 2,
      showNameEditScreen: false,
      // nameFormData: {
      //   'name': '',
      //   'email': ''
      // },
      // errNameForm: {
      //   'name': '',
      //   'email': ''
      // },

      nameFormData: {
        name: '',
        email: '',
        gender: '', // Add gender field to your component state
        ageGroup: '' // Add ageGroup field to your component state
      },
      errNameForm: {
        name: '',
        email: '',
        gender: '', // Add gender field to your component state
        ageGroup: '' // Add ageGroup field to your component state
      },


      backSummary: false,
      showMainSummaryModal: false,
      crrDetail: "",
      crrCodeUserDetails: {
        "employeeId": "",
        "name": "",
        "email": "",
        "mobile": "",
        "message": ""
      },
      errorsCrrCodeUserDetails: {},
      topFiveTalent: true,
      contactExpertSection: false,
      showMyExpertList: false,
      showVideoModal: '',
      showVideoResource: false,
      showMainMenu: "Summary",
      downloadStatusNo: 100,

      surveyLanguageCode: 'en',
      surveyLanguageName: 'English',
      surveyLanguageRTL: false,
    };


    this.handleShowMainSummaryModal = this.handleShowMainSummaryModal.bind(this);
    this.handleShowMainSummaryModalBack = this.handleShowMainSummaryModalBack.bind(this);
    this.handleExpertContactModalBack = this.handleExpertContactModalBack.bind(this);
    this.handleExpertContactModal = this.handleExpertContactModal.bind(this);
    this.handleInputExpertForm = this.handleInputExpertForm.bind(this);
    this.bookExpert = this.bookExpert.bind(this);
    this.handleExpertClick = this.handleExpertClick.bind(this);
    this.props.dispatch(assessmentActions.getTalentResources());


  }

  componentDidMount() {
    this.props.dispatch(questionsActions.emptyReducer());

    this.props.dispatch(questionsActions.getQuestionList({ code: this.state.SurveyCode }, "v4"));


    // this.props.dispatch(questionsActions.getTranslateElementAll());
    // this.props.dispatch(questionsActions.getLanguageLabel());



    // this.props.dispatch(questionsActions.getAssessmentQuestionList({}, "v4"));
    // this.props.dispatch(questionsActions.getAssessmentReport());
    // this.props.dispatch(questionsActions.getAssessmenrEmployeeDetails({}));
    // this.props.dispatch(questionsActions.getCoachUserSurveyList({}));
    // this.props.dispatch(questionsActions.getSurveyTakenDate({}));
    // this.props.dispatch(questionsActions.getAssessmentStatus({}));
    // this.props.dispatch(questionsActions.getAssessmenrEmployeeProduct({}));
  }

  decrementNumber = () => {
    this.setState((prevState) => ({
      downloadStatusNo: prevState.downloadStatusNo < 1 ? 0 : prevState.downloadStatusNo - 10,
    }));
  };



  static getDerivedStateFromProps(nextProps) {
    if (nextProps.questions.submitfail) {
      return {
        ...nextProps,
        showWelcomeScreen: false,
        showQuestionScreen: false,
        showThankyouScreen: false,
        instructionPage: false,

        alreadySubmitted: true,
      };
    }
    if (nextProps.questions.answerSubmitSuccess) {
      return {
        ...nextProps,
        showWelcomeScreen: false,
        showQuestionScreen: false,
        showThankyouScreen: true,
        instructionPage: false,
      };
    } else {
      return {
        ...nextProps,
      };
    }
  }

  prevQues = () => {
    this.setState({ changeType: "fade1" });
    this.setState({ ShowSubmitButton: false });
    this.setState({ submitMandatory: "" });
    let { questions } = this.props;
    let { questionsList } = questions;
    let { CurrQuesIndex } = this.state;
    if (questionsList && questionsList.length > 0) {
      if (CurrQuesIndex > 1 && CurrQuesIndex < questionsList.length + 1) {
        CurrQuesIndex = CurrQuesIndex - 1;

        this.setState({ CurrQuesIndex }, () => {
          // this.handleSubmitAppear();
        });
      } else {
        this.setState({
          showWelcomeScreen: false,
          showQuestionScreen: false,
          showThankyouScreen: false,
          instructionPage: true,
        });
      }
    }

    // console.log("answersList: ", answersList)
  };

  nextQues = (type2) => {
    console.log("Next Question!");
    clearTimeout(this.state.setTimeoutRef);
    clearInterval(this.state.setIntervalRef);
    window.scrollTo(0, 0);
    this.setState({ changeType: "fade", clicked: "" }, () => {
      let { questions } = this.props;
      let { questionsList, surveyScreenData, GroupQuestionOnlyList } =
        questions;
      let { CurrQuesIndex } = this.state;
      let itemQ =
        questionsList && questionsList.length > 0
          ? questionsList[CurrQuesIndex]
          : {};
      //---------------------------- basic ---------------------------------------
      let answersList = [];
      let AnswerListFinal =
        answersList && questions.answersList && questions.answersList.length > 0
          ? questions.answersList
          : [];

      if (questionsList && questionsList.length > 0) {
        if (CurrQuesIndex < questions.questionsList.length) {
          this.props.dispatch(
            questionsActions.handleRecordResTime(
              0,
              itemQ,
              AnswerListFinal,
              questionsList,
              surveyScreenData,
              GroupQuestionOnlyList
            )
          );
        }

        questionsList.forEach((ques) => {
          if (ques.templateId === 13) {
            let getIndex = AnswerListFinal.findIndex(
              (prev) => prev.questionId === ques.id
            );
            if (getIndex !== -1) {
              answersList.push({
                ...AnswerListFinal[getIndex],
                SubQuestionList: ques.SubQuestionList,
              });
            }
          } else {
            let getIndex = AnswerListFinal.findIndex(
              (prev) => prev.questionId === ques.id
            );
            if (getIndex !== -1) {
              answersList.push(AnswerListFinal[getIndex]);
            }
          }
        });
      }
      //-------------------------------------------------------------------
      let isFeedback = false;
      if (questionsList && questionsList.length > 0) {
        if (CurrQuesIndex > 0 && CurrQuesIndex < questionsList.length) {
          //----------------latestcode ---------------------------
          //console.log("11111111111------>", CurrQuesIndex);

          let questionId =
            questionsList &&
              questionsList[CurrQuesIndex - 1] &&
              questionsList[CurrQuesIndex - 1].id
              ? questionsList[CurrQuesIndex - 1].id
              : "";
          let questionData =
            questionsList &&
              questionsList[CurrQuesIndex - 1] &&
              questionsList[CurrQuesIndex - 1].id
              ? questionsList[CurrQuesIndex - 1]
              : {};
          let flag = 0;

          if (answersList && answersList.length > 0) {
            let getIndex2 = answersList.findIndex(
              (prev) => prev.questionId === questionId
            );
            if (getIndex2 !== -1) {
              let item = answersList[getIndex2];

              //New added feedback
              if (
                item.answer &&
                questionData &&
                questionData.optionsList &&
                questionData.optionsList.length > 0
              ) {
                let optionList = questionData.optionsList;

                let getIndex5 = optionList.findIndex(
                  (prev) => prev.name === item.answer
                );
                if (getIndex5 !== -1) {
                  isFeedback = optionList[getIndex5]["isFeedback"]
                    ? true
                    : false;
                }
              }

              if (item.isMandatory) {
                let template = item.template;

                if (
                  template === 1 ||
                  template === 3 ||
                  template === 4 ||
                  template === 5 ||
                  template === 6 ||
                  template === 16 ||
                  template === 11
                ) {
                  if (!item.answer) {
                    flag = flag + 1;
                  }
                } else if (template === 13) {
                  let isAllAnswered = 0;
                  if (
                    item &&
                    item.SubQuestionList &&
                    item.SubQuestionList.length > 0
                  ) {
                    item.SubQuestionList.forEach((subQues) => {
                      let getIndex2 = AnswerListFinal.findIndex(
                        (prev) => prev.questionId === subQues.id
                      );

                      if (getIndex2 !== -1) {
                        if (
                          AnswerListFinal &&
                          AnswerListFinal[getIndex2] &&
                          AnswerListFinal[getIndex2].multiAnswer &&
                          AnswerListFinal[getIndex2].multiAnswer.length > 1
                        ) {
                          isAllAnswered++;
                        }
                      }
                    });
                  }

                  if (item.SubQuestionList.length !== isAllAnswered) {
                    flag = flag + 1;
                  }
                } else if (template === 2) {
                  if (
                    !(item && item.multiAnswer && item.multiAnswer.length > 0)
                  ) {
                    flag = flag + 1;
                  }
                } else {
                  if (!item.answer) {
                    flag = flag + 1;
                  }
                }
              }
            }
          }

          if (!flag) {
            try {
              let cryptedText = CryptoJS.AES.encrypt(
                JSON.stringify(AnswerListFinal),
                "secretkey1345100237401"
              ).toString();
              localStorage.setItem("myAnswers", JSON.stringify(cryptedText));
            } catch (error) {
              console.log("not saved!");
            }

            //console.log("isFeedback----------->", isFeedback);

            if (isFeedback && type2 !== 2) {
              this.setState({ showFeedbackModal: true });
            } else {
              CurrQuesIndex = CurrQuesIndex + 1;

              this.setState({ CurrQuesIndex }, () => {
                this.setState({
                  ShowNotAttempted: false,
                  showFeedbackModal: false,
                });

                this.handleSubmitAppear();
              });
            }
          } else {
            this.setState({ ShowNotAttempted: true });
          }

          // console.log("CurrQuesIndex------>", CurrQuesIndex);
          // console.log("questionsList.length------>", questionsList.length);
          // console.log("itemQ------>", itemQ);

          if (itemQ && itemQ.seconds && !this.state.disableTimer) {
            if (CurrQuesIndex < questionsList.length) {
              let setTimeoutRef = setTimeout(
                () => this.nextQues(),
                itemQ.seconds * 1000
              );
              this.setState(
                {
                  timeCounter: itemQ.seconds,
                  setTimeoutRef: setTimeoutRef,
                  setTimeoutInit: moment().unix(),
                },
                () => {
                  let setIntervalRef = setInterval(
                    () =>
                      this.setState({
                        timeCounter:
                          this.state.timeCounter > 0
                            ? this.state.timeCounter - 1
                            : 0,
                      }),
                    1000
                  );
                  this.setState({ setIntervalRef: setIntervalRef });
                }
              );
            } else {
              let setTimeoutRef = setTimeout(
                () => this.saveAnswers(),
                itemQ.seconds * 1000
              );
              this.setState(
                {
                  timeCounter: itemQ.seconds,
                  setTimeoutRef: setTimeoutRef,
                  setTimeoutInit: moment().unix(),
                },
                () => {
                  let setIntervalRef = setInterval(
                    () =>
                      this.setState({
                        timeCounter:
                          this.state.timeCounter > 0
                            ? this.state.timeCounter - 1
                            : 0,
                      }),
                    1000
                  );
                  this.setState({ setIntervalRef: setIntervalRef });
                }
              );
            }
          }
        } else if (CurrQuesIndex === questionsList.length) {
          //console.log("222222222------>", CurrQuesIndex);

          let questionId =
            questionsList &&
              questionsList[CurrQuesIndex - 1] &&
              questionsList[CurrQuesIndex - 1].id
              ? questionsList[CurrQuesIndex - 1].id
              : "";
          let questionData =
            questionsList &&
              questionsList[CurrQuesIndex - 1] &&
              questionsList[CurrQuesIndex - 1].id
              ? questionsList[CurrQuesIndex - 1]
              : {};

          if (answersList && answersList.length > 0) {
            let getIndex2 = answersList.findIndex(
              (prev) => prev.questionId === questionId
            );
            if (getIndex2 !== -1) {
              let item = answersList[getIndex2];

              //New added feedback
              if (
                item.answer &&
                questionData &&
                questionData.optionsList &&
                questionData.optionsList.length > 0
              ) {
                let optionList = questionData.optionsList;

                let getIndex5 = optionList.findIndex(
                  (prev) => prev.name === item.answer
                );
                if (getIndex5 !== -1) {
                  isFeedback = optionList[getIndex5]["isFeedback"]
                    ? true
                    : false;
                }
              }
            }
          }

          if (isFeedback && type2 !== 2) {
            this.setState({ showFeedbackModal: true });
          }
        }
      }
    });
  };

  submitFeedback = () => {
    let { CurrQuesIndex } = this.state;
    let { questions } = this.props;
    let { questionsList } = questions;

    if (questionsList && questionsList.length > 0) {
      if (CurrQuesIndex === questionsList.length) {
        this.setState({ showFeedbackModal: false }, () => {
          this.handleSubmitAppear();
        });
      } else {
        CurrQuesIndex = CurrQuesIndex + 1;
        this.setState({ CurrQuesIndex }, () => {
          this.setState({ ShowNotAttempted: false, showFeedbackModal: false });
          this.handleSubmitAppear();
        });
      }
    }
  };

  closeFeedbackModal = () => {
    this.setState({ showFeedbackModal: false });
  };

  handleSubmitAppear = () => {
    let { CurrQuesIndex } = this.state;
    let { questions } = this.props;
    let { questionsList } = questions;
    setTimeout(() => {
      if (
        questionsList &&
        questionsList.length > 0 &&
        questionsList.length === CurrQuesIndex
      ) {
        this.setState({ ShowSubmitButton: true });
      } else {
        this.setState({ ShowSubmitButton: false });
      }
    }, 300);
  };

  handleRadio = (Index, ques, currentOption) => {
    this.setState({ clicked: currentOption.id });

    let { questions } = this.props;
    let {
      questionsList,
      answersList,
      surveyScreenData,
      GroupQuestionOnlyList,
      langList
    } = questions;

    let { CurrQuesIndex } = this.state;

    if (this.state.radioButton === currentOption.id) {
      this.setState({ radioButton: null });
      this.props.dispatch(
        questionsActions.handleSubmitPreChange(
          ques,
          answersList,
          questionsList,
          "",
          0,
          surveyScreenData,
          "",
          GroupQuestionOnlyList,
          langList
        )
      );
    } else {
      // console.log("currentOption----------------------IIIIIIIIIIIIIIIIIIIIIIIII--------------------->",currentOption)
      this.setState({ radioButton: currentOption.id });
      this.props.dispatch(
        questionsActions.handleSubmitPreChange(
          ques,
          answersList,
          questionsList,
          currentOption,
          currentOption.weightage,
          surveyScreenData,
          Index,
          GroupQuestionOnlyList,
          langList
        )
      );
    }

    this.setState({ radioButton: null });

    // if(!ques.parentId){
    //   setTimeout(()=>this.nextQues(), 300);
    // }
    // setTimeout(()=>this.checkFeedback(), 300);

    let resTime = 0;
    if (this.state.setTimeoutInit) {
      const then = moment.unix(this.state.setTimeoutInit);
      resTime = moment().diff(then, "milliseconds");
    } else {
      resTime = 0;
    }

    this.props.dispatch(
      questionsActions.handleRecordResTime(
        resTime,
        ques,
        answersList,
        questionsList,
        surveyScreenData,
        GroupQuestionOnlyList
      )
    );

    // console.log("-----questionsListlength---->", questionsList.length);
    // console.log("-----CurrQuesIndex---->", CurrQuesIndex);

    if (questionsList && questionsList.length > 0 && !this.state.disableTimer) {
      if (questionsList.length - 1 >= CurrQuesIndex) {
        clearTimeout(this.state.setTimeoutRef);
        clearInterval(this.state.setIntervalRef);
      }

      if (CurrQuesIndex === questionsList.length) {
        this.saveAnswers();
      } else if (CurrQuesIndex <= questionsList.length - 1) {
        clearTimeout(this.state.setTimeoutRef);
        clearInterval(this.state.setIntervalRef);
      }
    }

    setTimeout(() => this.nextQues(), 300);
  };

  handleCheckInput = (Index, ques, currentOption) => {
    this.setState({ clicked: currentOption.id });

    let { questions } = this.props;
    let {
      questionsList,
      answersList,
      surveyScreenData,
      GroupQuestionOnlyList,
    } = questions;

    if (true) {
      this.setState({ radioButton: currentOption.id });
      // console.log("currentOption::", currentOption)
      this.props.dispatch(
        questionsActions.handleSubmitPreChange(
          ques,
          answersList,
          questionsList,
          currentOption,
          currentOption.weightage,
          surveyScreenData,
          "",
          GroupQuestionOnlyList
        )
      );
    }
    // setTimeout(()=>this.nextQues(), 300);
  };

  goToInstructionPage = () => {
    let { questions } = this.props;
    let { surveyScreenData } = questions;

    if (surveyScreenData.isInstruction) {
      this.setState({
        showWelcomeScreen: false,
        showQuestionScreen: false,
        showThankyouScreen: false,
        instructionPage: true,
        showNameEditScreen: false
      });
    } else {
      let { questionsList } = questions;
      let itemQ =
        questionsList && questionsList.length > 0 ? questionsList[0] : {};
      //console.log("itemQ--01-->", itemQ);

      if (itemQ && itemQ.seconds && !this.state.disableTimer) {
        //console.log("Seconds--->", itemQ.seconds * 1000);
        let setTimeoutRef = setTimeout(
          () => this.nextQues(),
          itemQ.seconds * 1000
        );
        this.setState(
          {
            timeCounter: itemQ.seconds,
            setTimeoutRef: setTimeoutRef,
            setTimeoutInit: moment().unix(),
          },
          () => {
            let setIntervalRef = setInterval(
              () =>
                this.setState({
                  timeCounter:
                    this.state.timeCounter > 0 ? this.state.timeCounter - 1 : 0,
                }),
              1000
            );
            this.setState({ setIntervalRef: setIntervalRef });
          }
        );
      }

      this.setState({
        showWelcomeScreen: false,
        showQuestionScreen: true,
        showThankyouScreen: false,
        instructionPage: false,
        showNameEditScreen: false
      });
    }
    window.scrollTo(0, 0);
  };

  goToQuestionPage = () => {
    let { questions } = this.props;
    let { questionsList } = questions;
    let itemQ =
      questionsList && questionsList.length > 0 ? questionsList[0] : {};
    //console.log("itemQ--02-->", itemQ);

    if (itemQ && itemQ.seconds && !this.state.disableTimer) {
      //console.log("Seconds--->", itemQ.seconds * 1000);
      let setTimeoutRef = setTimeout(
        () => this.nextQues(),
        itemQ.seconds * 1000
      );
      this.setState(
        {
          timeCounter: itemQ.seconds,
          setTimeoutRef: setTimeoutRef,
          setTimeoutInit: moment().unix(),
        },
        () => {
          let setIntervalRef = setInterval(
            () =>
              this.setState({
                timeCounter:
                  this.state.timeCounter > 0 ? this.state.timeCounter - 1 : 0,
              }),
            1000
          );
          this.setState({ setIntervalRef: setIntervalRef });
        }
      );
    }

    this.setState({
      showWelcomeScreen: false,
      showQuestionScreen: true,
      showThankyouScreen: false,
      instructionPage: false,
    });
    window.scrollTo(0, 0);
  };

  saveAnswers() {
    let { questions, userCode } = this.props;
    let { surveyScreenData } = questions;

    if (surveyScreenData) {
      this.setState({
        afterSubmitData: surveyScreenData,
      });
    }

    let survey = null;

    //---------------------- new code ------------------------------------------

    let { questionsList } = questions;

    //---------------------------- basic ---------------------------------------
    let answersList = [];
    let AnswerListFinal =
      answersList && questions.answersList && questions.answersList.length > 0
        ? questions.answersList
        : [];

    if (questionsList && questionsList.length > 0) {
      questionsList.forEach((ques) => {
        if (ques.templateId === 13) {
          let getIndex = AnswerListFinal.findIndex(
            (prev) => prev.questionId === ques.id
          );
          if (getIndex !== -1) {
            answersList.push({
              ...AnswerListFinal[getIndex],
              SubQuestionList: ques.SubQuestionList,
            });
          }
        } else {
          let getIndex = AnswerListFinal.findIndex(
            (prev) => prev.questionId === ques.id
          );
          if (getIndex !== -1) {
            answersList.push(AnswerListFinal[getIndex]);
          }
        }
      });
    }
    //-------------------------------------------------------------------

    let { CurrQuesIndex } = this.state;
    if (questionsList && questionsList.length > 0) {
      let flag = 0;
      // console.log(" CurrQuesIndex=====>: ",CurrQuesIndex," questionsList.length=====>: ", questionsList.length)

      if (CurrQuesIndex > 0 && CurrQuesIndex <= questionsList.length) {
        //----------------latestcode ---------------------------

        let questionId =
          questionsList &&
            questionsList[CurrQuesIndex - 1] &&
            questionsList[CurrQuesIndex - 1].id
            ? questionsList[CurrQuesIndex - 1].id
            : "";

        if (answersList && answersList.length > 0) {
          let getIndex2 = answersList.findIndex(
            (prev) => prev.questionId === questionId
          );
          if (getIndex2 !== -1) {
            let item = answersList[getIndex2];

            if (item.isMandatory) {
              let template = item.template;

              if (
                template === 1 ||
                template === 3 ||
                template === 4 ||
                template === 5 ||
                template === 6 ||
                template === 16 ||
                template === 11
              ) {
                if (!item.answer) {
                  flag = flag + 1;
                }
                // console.log(" template: ",template," answer: ",item.answer," flag: ",flag)
              } else if (template === 13) {
                let isAllAnswered = 0;
                if (
                  item &&
                  item.SubQuestionList &&
                  item.SubQuestionList.length > 0
                ) {
                  item.SubQuestionList.forEach((subQues) => {
                    let getIndex2 = AnswerListFinal.findIndex(
                      (prev) => prev.questionId === subQues.id
                    );

                    if (getIndex2 !== -1) {
                      if (
                        AnswerListFinal &&
                        AnswerListFinal[getIndex2] &&
                        AnswerListFinal[getIndex2].multiAnswer &&
                        AnswerListFinal[getIndex2].multiAnswer.length > 1
                      ) {
                        isAllAnswered++;
                      }
                    }
                  });
                }

                if (item.SubQuestionList.length !== isAllAnswered) {
                  flag = flag + 1;
                }
              } else if (template === 2) {
                if (
                  !(item && item.multiAnswer && item.multiAnswer.length > 0)
                ) {
                  flag = flag + 1;
                }
              } else {
                if (!item.answer) {
                  flag = flag + 1;
                }
              }
            }
          }
        }

      }

      if (!flag) {
        if (!this.state.isDisableSubmit) {
          clearTimeout(this.state.setTimeoutRef);
          clearInterval(this.state.setIntervalRef);

          console.log("Answer Submitted!");



          setTimeout(() => {
            this.setState({ showViewReportThankYouButton: true });
            this.interval = setInterval(this.decrementNumber, 500);
            setTimeout(() => {
              this.sendPDFMail(this.state.surveyLanguageCode)
              window.location.reload();
            }, 5000);
          }, 3000);

          this.props.dispatch(
            questionsActions.saveUserCodeAnswers(
              AnswerListFinal,
              userCode,
              this.state.IpObj,
              true
            )
          );
        }
        this.setState({ submitMandatory: "" });
      } else {
        this.setState({
          submitMandatory: "Please attempt mandatory question!",
        });
      }
    }

  }

  ansTextBoxClick(ques) {
    this.setState({ currQues: ques });
  }

  ansTextBoxChange1 = (e, Ques) => {
    let { questions } = this.props;
    let {
      questionsList,
      answersList,
      surveyScreenData,
      GroupQuestionOnlyList,
    } = questions;

    let ansData = {
      _id: "",
      name: e.target.value,
      ans: 1,
    };

    this.setState({ textAnswer: e.target.value });

    // console.log("ansData; ", ansData)

    this.props.dispatch(
      questionsActions.handleSubmitPreChange(
        Ques,
        answersList,
        questionsList,
        ansData,
        null,
        surveyScreenData,
        "",
        GroupQuestionOnlyList
      )
    );
  };

  handleFeedbackInput = (e, Ques) => {
    let { questions } = this.props;
    let {
      questionsList,
      answersList,
      surveyScreenData,
      GroupQuestionOnlyList,
    } = questions;

    let ansData = {
      name: e.target.value,
    };

    this.setState({ textAnswer: e.target.value });

    // console.log("ansData; ", ansData)

    this.props.dispatch(
      questionsActions.handleSubmitFeedbackChange(
        Ques,
        answersList,
        questionsList,
        ansData,
        null,
        surveyScreenData,
        "",
        GroupQuestionOnlyList
      )
    );
  };

  ansNPSInput = (val, ques) => {
    let { questions } = this.props;
    let {
      questionsList,
      answersList,
      surveyScreenData,
      GroupQuestionOnlyList,
    } = questions;

    let ansData = {
      _id: "",
      name: val,
      ans: 1,
    };

    this.setState({ textAnswer: val });

    let { CurrQuesIndex } = this.state;

    // console.log("ansData; ", ansData)

    this.props.dispatch(
      questionsActions.handleSubmitPreChange(
        ques,
        answersList,
        questionsList,
        ansData,
        null,
        surveyScreenData,
        "",
        GroupQuestionOnlyList
      )
    );

    let resTime = 0;
    if (this.state.setTimeoutInit) {
      const then = moment.unix(this.state.setTimeoutInit);
      resTime = moment().diff(then, "milliseconds");
      console.log(
        "resTime----------------------resTime--------------------->",
        resTime
      );
    } else {
      resTime = 0;
    }

    this.props.dispatch(
      questionsActions.handleRecordResTime(
        resTime,
        ques,
        answersList,
        questionsList,
        surveyScreenData,
        GroupQuestionOnlyList
      )
    );

    // console.log("-----questionsListlength---->", questionsList.length);
    // console.log("-----CurrQuesIndex---->", CurrQuesIndex);

    if (questionsList && questionsList.length > 0 && !this.state.disableTimer) {
      if (questionsList.length - 1 >= CurrQuesIndex) {
        clearTimeout(this.state.setTimeoutRef);
        clearInterval(this.state.setIntervalRef);
      }

      if (CurrQuesIndex === questionsList.length) {
        this.saveAnswers();
      } else if (CurrQuesIndex <= questionsList.length - 1) {
        clearTimeout(this.state.setTimeoutRef);
        clearInterval(this.state.setIntervalRef);
      }
    }

    // if(!Ques.parentId){
    //   setTimeout(()=>this.nextQues(), 300);
    // }
    setTimeout(() => this.nextQues(), 300);
  };

  ansTextBoxChange2 = (e, Ques) => {
    let { questions } = this.props;
    let {
      questionsList,
      answersList,
      surveyScreenData,
      GroupQuestionOnlyList,
    } = questions;

    let ansData = {
      _id: "",
      name: e.target.value,
      ans: 2,
    };

    this.setState({ textAnswer: e.target.value });

    // console.log("ansData; ", ansData)

    this.props.dispatch(
      questionsActions.handleSubmitPreChange(
        Ques,
        answersList,
        questionsList,
        ansData,
        null,
        surveyScreenData,
        "",
        GroupQuestionOnlyList
      )
    );
  };

  clickOK = () => {
    // setTimeout(()=>this.nextQues(), 300);
    this.nextQues();
  };

  clickOKLast = (Ques) => {
    // console.log("clickOKLast; ")

    let { questions } = this.props;
    let {
      questionsList,
      answersList,
      surveyScreenData,
      GroupQuestionOnlyList,
    } = questions;

    let ansData = {
      _id: "",
      name: "",
      ans: 3,
    };

    this.props.dispatch(
      questionsActions.handleSubmitPreChange(
        Ques,
        answersList,
        questionsList,
        ansData,
        null,
        surveyScreenData,
        "",
        GroupQuestionOnlyList
      )
    );

    let { CurrQuesIndex } = this.state;
    if (questionsList && questionsList.length > 0) {
      if (CurrQuesIndex > 0 && CurrQuesIndex < questionsList.length) {
        CurrQuesIndex = CurrQuesIndex + 1;

        this.setState({ CurrQuesIndex });
      }
    }

    let answersList2 = [];
    let AnswerListFinal =
      answersList && questions.answersList && questions.answersList.length > 0
        ? questions.answersList
        : [];
    if (questionsList && questionsList.length > 0) {
      questionsList.forEach((ques) => {
        if (ques.templateId === 13) {
          let getIndex = AnswerListFinal.findIndex(
            (prev) => prev.questionId === ques.id
          );
          if (getIndex !== -1) {
            answersList.push({
              ...AnswerListFinal[getIndex],
              SubQuestionList: ques.SubQuestionList,
            });
          }
        } else {
          let getIndex = AnswerListFinal.findIndex(
            (prev) => prev.questionId === ques.id
          );
          if (getIndex !== -1) {
            answersList.push(AnswerListFinal[getIndex]);
          }
        }
      });
    }

    let flag = 0;
    let unattemptList = [];
    answersList2.forEach((item, index) => {
      if (item.isMandatory) {
        let template = item.template;

        if (
          template === 1 ||
          template === 3 ||
          template === 4 ||
          template === 5 ||
          template === 6 ||
          template === 16 ||
          template === 11
        ) {
          if (!item.answer) {
            flag = flag + 1;
            unattemptList.push(index + 1);
          }
        } else if (template === 13) {
          let isAllAnswered = 0;
          if (item && item.SubQuestionList && item.SubQuestionList.length > 0) {
            item.SubQuestionList.forEach((subQues) => {
              let getIndex2 = AnswerListFinal.findIndex(
                (prev) => prev.questionId === subQues.id
              );
              if (
                AnswerListFinal &&
                AnswerListFinal[getIndex2] &&
                AnswerListFinal[getIndex2].multiAnswer &&
                AnswerListFinal[getIndex2].multiAnswer.length > 1
              ) {
                isAllAnswered++;
              }
            });
            if (item.SubQuestionList.length !== isAllAnswered) {
              flag = flag + 1;
              unattemptList.push(index + 1);
            }
          }
        } else if (template === 2) {
          if (!(item && item.multiAnswer && item.multiAnswer.length > 0)) {
            flag = flag + 1;
            unattemptList.push(index + 1);
          }
        } else {
          if (!item.answer) {
            flag = flag + 1;
            unattemptList.push(index + 1);
          }
        }
      }
    });


    if (flag) {
      this.setState({ unattemptList: unattemptList });

      if (this.state.mandatoryOn && questionsList && questionsList.length > 0) {
        if (this.state.unattemptList && this.state.unattemptList.length > 0) {
          // console.log("-----working x")
          this.setState({ CurrQuesIndex: unattemptList[0] });
          // console.log("-----working x 1")
        }
      }
    } else {
      this.setState({ unattemptList: [] });

      if (this.state.mandatoryOn && questionsList && questionsList.length > 0) {
        // console.log("All mandatory questions are attempted , now go to last question i.e. submit! ")
        this.setState({ CurrQuesIndex: questionsList.length });
      }
    }

    //nothing
  };

  onMandatoryAttempt = (elem) => {
    this.setState({ CurrQuesIndex: elem });
    this.setState({ mandatoryOn: true });
  };

  gotoSubmit = () => {
    let { questions } = this.props;
    let { questionsList } = questions;

    if (questionsList && questionsList.length > 0) {
      this.setState({ CurrQuesIndex: questionsList.length });
    }
  };

  // handleLanguage = (e) => {
  //   if (e.target.value === "en") {
  //     this.setState({ surveyLanguageCode: "", surveyLanguageName: "" });
  //   } else {
  //     this.setState({
  //       surveyLanguageCode: e.target.value,
  //       surveyLanguageName: "",
  //     });
  //   }
  // };

  openDropdownQuestion = (check) => {
    this.setState({ showDropdownQues: check });
  };

  handleDropdownSelect = (value) => {
    this.setState({ dropdownInput: value, showDropdownQues: false });
  };

  handleMatrixRadio = (ques, subQues, currentOption) => {
    let { questions } = this.props;
    let {
      questionsList,
      answersList,
      surveyScreenData,
      GroupQuestionOnlyList,
    } = questions;


    //console.log('------>answersList------>',answersList)

    this.props.dispatch(
      questionsActions.handleSubmitPreChange(
        ques,
        answersList,
        questionsList,
        currentOption,
        currentOption.weightage,
        surveyScreenData,
        subQues,
        GroupQuestionOnlyList
      )
    );

    // setTimeout(()=>this.nextQues(), 300);
  };

  handleReport = () => {
    this.props.dispatch(questionsActions.getAssessmentReport({}));
    this.setState({ showReportModal: true });
  };

  handleSummaryReport = (_, type) => {
    this.props.dispatch(questionsActions.getAssessmentReport({
      "type": type
    }));
    // this.setState({ showSummaryReport: true });
  };
  goToSummary = () => {
    window.location.reload();
  }

  viewReport = (type) => {
    let { questions, temp } = this.props;
    let { getAssessmenrEmployeeProductData } = questions;
    let ele = getAssessmenrEmployeeProductData;
    console.log("ele 1-->", ele);
    if (ele && ele.productId && ele.productId.code) {
      let code = ele.productId.code;
      this.handleSummaryReport(ele, type);

      if (code === "Top5TalentplusStrengths") {
        console.log("Top5TalentplusStrengths 1-->");

        this.setState({
          showReportModal: false,
          showSummaryReport: true,
          showManagerReportModal: false,
          showHiringReportModal: false,
          showSchoolReportModal: false
        });

      } else if (code === "TalentPlusStrengths21") {
        console.log("TalentPlusStrengths21 1-->");
        // this.handleReport(ele);


        this.setState({
          showReportModal: true,
          showSummaryReport: false,
          showManagerReportModal: false,
          showHiringReportModal: false,
          showSchoolReportModal: false
        });
      } else if (code === "TalentplusManagerStrengths") {
        console.log("TalentplusManagerStrengths 1-->");
        // this.handleManagerReport(ele);


        this.setState({
          showReportModal: false,
          showSummaryReport: false,
          showManagerReportModal: true,
          showHiringReportModal: false,
          showSchoolReportModal: false
        });
      } else if (code === "TalentPlusHiringStrengths") {
        console.log("TalentPlusHiringStrengths 1-->");
        // this.handleHiringReport(ele);


        this.setState({
          showReportModal: false,
          showSummaryReport: false,
          showManagerReportModal: false,
          showHiringReportModal: true,
          showSchoolReportModal: false
        });
      } else if (code === "Top5TeenTalentplusStrengths") {
        // this.handleSchoolReport(ele);


        this.setState({
          showReportModal: false,
          showSummaryReport: false,
          showManagerReportModal: false,
          showHiringReportModal: false,
          showSchoolReportModal: true
        });
      }

    };


    this.setState({ crrEmpDetails: temp });
  };


  handleHiringReport = () => {
    this.props.dispatch(questionsActions.getAssessmentReport({}));
    this.setState({ showHiringReportModal: true });
  };

  closeReportModal = () => {
    this.setState({ showReportModal: false });
  };

  closeSummaryReportModal = () => {
    this.setState({ showSummaryReport: false });
  };

  closeManagerReportModal = () => {
    this.setState({ showManagerReportModal: false });
  };

  closeHiringReportModal = () => {
    this.setState({ showHiringReportModal: false });
  };

  handleLanguage = (item) => {
    console.log("item------------------->", item);
    if (item.shortName === "en") {
      this.setState({
        surveyLanguageCode: item.shortName,
        surveyLanguageName: "English",
        surveyLanguageRTL: false,
      });
    } else {
      this.setState({
        surveyLanguageCode: item.shortName,
        surveyLanguageName: item.name,
        surveyLanguageRTL: item.isRTL,
      });
    }
  };

  handleDownloadStatus = () => {
    let data = {
      moduleType: "ASSESSMENT",
    };
    this.props.dispatch(assessmentActions.assessmentDownloadStatus(data));
  };




  goToUpdateDetailsPage = () => {

    if (false) {

      let { questions } = this.props;
      let { getAssessmenrEmployeeDetailsData } = questions;
      if (getAssessmenrEmployeeDetailsData && getAssessmenrEmployeeDetailsData.name && getAssessmenrEmployeeDetailsData.email) {
        this.goToInstructionPage()
      } else {
        let { nameFormData } = this.state;
        nameFormData["name"] = getAssessmenrEmployeeDetailsData && getAssessmenrEmployeeDetailsData.name ? getAssessmenrEmployeeDetailsData.name : "";
        if (getAssessmenrEmployeeDetailsData && getAssessmenrEmployeeDetailsData.name) {
          nameFormData["email"] = getAssessmenrEmployeeDetailsData && getAssessmenrEmployeeDetailsData.email ? getAssessmenrEmployeeDetailsData.email : "";
        }
        // this.setState({
        //   nameFormData,
        //   showNameEditScreen: true
        // })
        this.setState({
          nameFormData,
          showNameEditScreen: false
        })
      }

    } else {
      this.goToInstructionPage()
    }

    window.scrollTo(0, 0);
  };

  handleNameInput = (e) => {
    let { nameFormData } = this.state;
    nameFormData[e.target.name] = e.target.value;
    this.setState({ nameFormData })
  }


  onUpdateDetails = () => {
    let { nameFormData, errNameForm } = this.state;
    let { questions, userCode } = this.props;
    let { getAssessmentStatusData } = questions;
    let isSchool = getAssessmentStatusData && getAssessmentStatusData.isSchool ? true : false;


    if (!nameFormData.name) {
      errNameForm["name"] = 'Please enter your name';
    } else {
      errNameForm["name"] = "";
    }


    if (!nameFormData.email) {
      errNameForm["email"] = 'Please enter your email';
    } else {
      const emailPattern =
        /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      const isValid = emailPattern.test(nameFormData["email"]);

      // let validE = validateEmail(nameFormData["email"]);
      console.log("isValid---------------------->", isValid)

      if (!isValid) {
        errNameForm["email"] = 'Please enter valid email';
      } else {
        errNameForm["email"] = "";
      }
    }

    if (isSchool) {
      if (!nameFormData.gender) {
        errNameForm["gender"] = 'Please select your gender';
      } else {
        errNameForm["gender"] = '';
      }

      if (!nameFormData.ageGroup) {
        errNameForm["ageGroup"] = 'Please select your Age Group';
      } else {
        errNameForm["ageGroup"] = '';
      }
    }


    this.setState({ errNameForm }, () => {

      console.log("errNameForm---->", errNameForm)
      if ((isSchool ? (errNameForm["gender"] === "" && errNameForm["ageGroup"] === "") : true) && (errNameForm["name"] === "" && errNameForm["email"] === "")) {

        let data = {
          name: nameFormData.name,
          email: nameFormData.email,
          code: userCode
        };

        if (isSchool) {
          data["gender"] = nameFormData.gender;
          data["ageGroup"] = nameFormData.ageGroup;
        }
        this.props.dispatch(questionsActions.updateUserEndDetails(data));
        this.goToInstructionPage()
        this.setState({
          errNameForm: {
            'name': '', 'email': '', 'gender': '', 'ageGroup': '' // Reset error for gender field
          },
          nameFormData: {
            'name': '', 'email': '', 'gender': '', 'ageGroup': '' // Reset form for gender field
          }
        })


      }
    })

  }

  handleGenderChange = (e) => {
    const { nameFormData } = this.state;
    const selectedGender = e.target.value;

    this.setState({
      nameFormData: {
        ...nameFormData,
        gender: selectedGender
      }
    });
  }

  handleAgeGroupChange = (e) => {
    const { nameFormData } = this.state;
    const selectedAgeGroup = e.target.value;

    this.setState({
      nameFormData: {
        ...nameFormData,
        ageGroup: selectedAgeGroup
      }
    });
  }


  loadExpertData = () => {
    let { questions } = this.props;
    let { getAssessmenrEmployeeDetailsData } = questions;

    if (getAssessmenrEmployeeDetailsData && getAssessmenrEmployeeDetailsData.id) {
      let eleUser = getAssessmenrEmployeeDetailsData;
      let temp2 = {
        employeeId: eleUser && eleUser.id ? eleUser.id : "",
        name: eleUser && eleUser.name ? eleUser.name : "",
        email: eleUser && eleUser.email ? eleUser.email : "",
        mobile: eleUser && eleUser.mobile ? eleUser.mobile : ""
      };
      this.setState({ crrCodeUserDetails: temp2 });
    }

    this.props.dispatch(assessmentActions.getExpertDetailsList());
    this.props.dispatch(assessmentActions.getExpertOrderBookList());
  }



  handleShowMainSummaryModalBack() {

    this.setState({ showMainSummaryModal: true, showMyExpertList: false, backSummary: false, top5Talent: false });
  }

  handleShowMainSummaryModal(ele) {

    this.loadExpertData()
    this.props.dispatch(assessmentActions.userAssessmentExpertOrderEmpty());

    this.setState({ showMainSummaryModal: false, backSummary: true, showMyExpertList: false, crrDetail: ele, top5Talent: true });
  }

  handleExpertContactModal(ele) {
    this.loadExpertData()
    this.props.dispatch(assessmentActions.userAssessmentExpertOrderEmpty());
    this.setState({
      contactExpertSection: ele, topFiveTalent: false
    });
  }

  handleExpertContactModalBack() {
    this.props.dispatch(assessmentActions.userAssessmentExpertOrderEmpty());
    this.setState({
      contactExpertSection: false, topFiveTalent: true
    });
  }
  handleInputExpertForm(value, name) {
    let { crrCodeUserDetails, errorsCrrCodeUserDetails } = this.state;
    crrCodeUserDetails[name] = value;
    errorsCrrCodeUserDetails[name] = "";
    this.setState({ crrCodeUserDetails, errorsCrrCodeUserDetails });
  }

  // inputChangeUpdateUser = (e) => {
  //   e.preventDefault();
  //   let { name, value } = e.target;
  //   let fieldsUserUpdate = this.state.fieldsUserUpdate;
  //   let errorsUpdateQuote = this.state.errorsUpdateQuote;
  //   fieldsUserUpdate[name] = value;
  //   errorsUpdateQuote[name] = "";
  //   console.log(name, value);
  //   this.setState({ fieldsUserUpdate, errorsUpdateQuote });
  // }

  bookExpert(userDetails, expertDetails) {

    if (this.handleValidationUpdateUser()) {
      let data = {
        "name": userDetails.name,
        "email": userDetails.email,
        "mobile": userDetails.mobile,
        "message": userDetails.message,
        "expertId": expertDetails.id,
      }
      console.log("--------->data<---------123123123131-------", data)

      this.props.dispatch(assessmentActions.userAssessmentExpertOrderPlace(data));

    }

  }

  handleValidationUpdateUser = () => {
    let crrCodeUserDetails = this.state.crrCodeUserDetails;
    let errorsCrrCodeUserDetails = {};
    let formIsValid = true;

    //name
    if (!crrCodeUserDetails["name"] || crrCodeUserDetails["name"] === "") {
      formIsValid = false;
      errorsCrrCodeUserDetails["name"] = "Name cannot be empty";
    }

    //email
    if (!crrCodeUserDetails["email"] || crrCodeUserDetails["email"] === "") {
      formIsValid = false;
      errorsCrrCodeUserDetails["email"] = "Email cannot be empty";
    }
    //mobile
    if (!crrCodeUserDetails["mobile"] || crrCodeUserDetails["mobile"] === "") {
      formIsValid = false;
      errorsCrrCodeUserDetails["mobile"] = "Mobile cannot be empty";
    }
    //message
    if (!crrCodeUserDetails["message"] || crrCodeUserDetails["message"] === "") {
      formIsValid = false;
      errorsCrrCodeUserDetails["message"] = "Message cannot be empty";
    }
    console.log("errorsCrrCodeUserDetailserrorsCrrCodeUserDetails:::::", errorsCrrCodeUserDetails);
    this.setState({ errorsCrrCodeUserDetails: errorsCrrCodeUserDetails });
    return formIsValid;
  }

  handleExpertClick() {
    const { history } = this.props;
    history.push('/assessment/expert'); // Replace '/expert-page' with the actual route of your expert page
  }

  viewMyExpert = () => {
    this.loadExpertData()
    this.props.dispatch(assessmentActions.userAssessmentExpertOrderEmpty());
    this.setState({ backSummary: true, showMyExpertList: true })

  }

  handlePlayVideo = (dimension) => {
    console.log("dimension:::::", dimension);
    this.setState({ showVideoModal: dimension });
  }

  closeVideoModal = () => {
    this.setState({ showVideoModal: '' });
  }

  viewMyVideoReport = () => {
    this.setState({ showVideoResource: true })
  }

  closeVideoCourse = () => {
    this.setState({ showVideoResource: false })
  }

  handleMainMenu = (value) => {
    this.setState({ showMainMenu: value }, () => {
      if (value === "Summary") {
        this.setState({ backSummary: false, top5Talent: false })
      } else if (value === "VideoTutorials") {
        this.viewMyVideoReport();
      } else if (value === "Report") {
        this.viewReport();
      } else if (value === "Top5Summary") {
        this.viewReport("Top5Summary");
      } else if (value === "Experts") {
        this.viewMyExpert();
      }
    });
  }

  // handleMainMenu = (newRouteMenu) => {
  //   this.setState({ routeMenu: newRouteMenu }, () => {
  //     if (newRouteMenu === "Summary") {
  //       // Your logic for Summary
  //     } else if (newRouteMenu === "VideoTutorials") {
  //       // Your logic for VideoTutorials
  //     } else if (newRouteMenu === "Report") {
  //       // Your logic for Report
  //     } else if (newRouteMenu === "Experts") {
  //       // Your logic for Experts
  //     }
  //   });
  // }


  downloadRTLReport = (value, lang) => {
    this.props.dispatch(assessmentActions.getUserAssessmentLangReport({
      shortName: value
    }, lang));

  }

  sendPDFMail = (value) => {
    this.props.dispatch(assessmentActions.getAssessmentReportMail({ shortName: value, isTest: true }));
  }

  getBadgeStyle = (status) => {
    switch (status) {
      case 'Completed':
        return 'bg-emerald-50 text-emerald-500 border-emerald-100';
      case 'In-Progress':
        return 'bg-amber-50 text-amber-500 border-amber-100';
      case 'Not started':
      default:
        return 'bg-blue-50 textcolor border-purple-100';
    }
  };

  render() {
    const { routeMenu } = this.state;
    let { questions, assessment, onLogout, handleTestPayment,
      onAssessmentSummary, switchToAdmin, openAIBot,
      getCoachUserSurveyListData
    } = this.props;
    let {
      userAssessmentExpertOrderPlaceData,
      getExpertOrderBookListData,
      getTalentResourcesData
    } = assessment;

    let {
      getAssessmentStatusData,
      getAssessmentReportByEmpIDData,
      getAssessmenrEmployeeDetailsData,
      questionsList,
      answersList,
      surveyStatus,
      GroupQuestionOnlyList,
      getTranslateElementAllData,
      loading,
      getSurveyTakenDateData
    } = questions;

    let check =
      getAssessmentStatusData && getAssessmentStatusData.check
        ? getAssessmentStatusData.check
        : 0;
    let isSchool =
      getAssessmentStatusData && getAssessmentStatusData.isSchool
        ? true
        : false;

    let createdAt =
      getSurveyTakenDateData && getSurveyTakenDateData.createdAt
        ? moment(parseInt(getSurveyTakenDateData.createdAt))
          .utcOffset("+05:30")
          .format("DD MMMM, YYYY")
        : "";


    let {
      timeCounter,
      showFeedbackModal,
      CurrQuesIndex,
      afterSubmitData,
      clicked,
      ShowNotAttempted,
      submitMandatory,
      showViewReportThankYouButton,
      showSummaryReport,
      showManagerReportModal,
      showHiringReportModal,
      themeType,
      showNameEditScreen,
      nameFormData,
      errNameForm,
      showMyExpertList,
      showVideoModal,
      showVideoResource,
      showMainMenu,
      showSchoolReportModal,
      downloadStatusNo,
      surveyLanguageRTL
    } = this.state;


    console.log("isSchool-11111-->", isSchool)
    // console.log('showMainMenushowMainMenushowMainMenushowMainMenushowMainMenu', showMainMenu);

    let { UserRespondantName } = this.props;

    let { showReportModal, surveyLanguageCode, surveyLanguageName } =
      this.state;

    const isMobile = window.innerWidth <= 700;

    let surveyScreenData = {};
    if (questions.surveyScreenData) {
      surveyScreenData = { ...questions.surveyScreenData };

    }

    let bgImage = "";
    let bgColor = "";
    if (surveyScreenData && surveyScreenData.bgImage) {
      bgImage = "url(" + surveyScreenData.bgImage + ")";
    }

    if (surveyScreenData && surveyScreenData.bgColor) {
      bgColor = surveyScreenData.bgColor;
    }

    let welcomeTextDislay = [];
    let instructionTextDislay = [];

    if (surveyScreenData && surveyScreenData.welcomeText) {
      welcomeTextDislay = surveyScreenData.welcomeText;
      instructionTextDislay = surveyScreenData.instructionText;
    }

    let surveytitle = "";
    let bgType = "";

    if (surveyScreenData && surveyScreenData.name) {
      surveytitle = surveyScreenData.name;
      bgType = surveyScreenData.bgType;
    }

    let LabelObj = questions.getLanguageLabelData;
    let LanguageList = questions.langList;


    function showRadioMatrix(SubQues, option) {
      let getIndex1 = answersList.findIndex(
        (prev) => prev.questionId === SubQues.id
      );
      let getIndex4 = answersList[getIndex1]["multiAnswer"].findIndex(
        (prev) => prev.optionHead === option.heading
      );
      let getIndex3 = answersList[getIndex1]["multiAnswer"].findIndex(
        (prev) => prev.optionId === option.id
      );

      if (getIndex4 !== -1) {
        if (getIndex3 !== -1) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    }

    function FormatMatriXOptionHeading(question, isOption) {
      let paraObjShow = {};
      if (question && question.optionsList && question.optionsList.length > 0) {
        question.optionsList.forEach((item) => {
          if (paraObjShow && paraObjShow[item.heading]) {
            paraObjShow[item.heading] += 1;
          } else {
            paraObjShow[item.heading] = 1;
          }
        });
      }

      let headingList = [];
      let tempKey = Object.keys(paraObjShow);
      if (tempKey && tempKey.length > 0) {
        tempKey.forEach((item) => {
          headingList.push({
            name: item,
            span: paraObjShow[item],
          });
        });
      }

      if (isOption) {
        let OptionList = [];
        if (headingList && headingList.length > 0) {
          headingList.forEach((heading) => {
            if (
              question &&
              question.optionsList &&
              question.optionsList.length > 0
            ) {
              question.optionsList.forEach((option) => {
                if (heading.name === option.heading) {
                  OptionList.push(option);
                }
              });
            }
          });
        }
        return OptionList;
      } else {
        return headingList;
      }
    }

    function TranslateQuestion(surveyLanguageCode, question) {
      return surveyLanguageCode !== ""
        ? question &&
          question.transl &&
          question.transl[surveyLanguageCode] &&
          question.transl[surveyLanguageCode].name
          ? question.transl[surveyLanguageCode].name
          : question.name
        : question.name;
    }

    function TranslationOptionMatrix(
      question,
      heading,
      surveyLanguageCode,
      type
    ) {
      let optionId = "";
      if (question && question.optionsList && question.optionsList.length > 0) {
        let Index = question.optionsList.findIndex(
          (prev) => prev.heading === heading
        );
        optionId = question.optionsList[Index].id;
      }
      let text =
        surveyLanguageCode !== ""
          ? question &&
            question.transl &&
            question.transl[surveyLanguageCode] &&
            question.transl[surveyLanguageCode].headingList &&
            question.transl[surveyLanguageCode].headingList[optionId]
            ? question.transl[surveyLanguageCode].headingList[optionId]
            : heading
          : heading;

      let arr = text.split("-");
      if (type === 1) {
        return arr && arr[0] ? arr[0] : text;
      }
      if (type === 2) {
        return arr && arr[0] ? arr[0] : text;
      } else if (type === 3) {
        return arr && arr[1] ? arr[1] : "";
      } else {
        return text;
      }
    }


    let { getSurveyTemplateByCodeData } = this.props;
    function SurveyAttributes(name) {
      return surveyLanguageCode !== ""
        ? getSurveyTemplateByCodeData &&
          getSurveyTemplateByCodeData.transl &&
          getSurveyTemplateByCodeData.transl[surveyLanguageCode] &&
          getSurveyTemplateByCodeData.transl[surveyLanguageCode][name]
          ? getSurveyTemplateByCodeData.transl[surveyLanguageCode][name]
          : ""
        : getSurveyTemplateByCodeData && getSurveyTemplateByCodeData[name]
          ? getSurveyTemplateByCodeData[name]
          : "";
    }


    function MandatoryMsg(Ques) {
      let Text = "";
      let Color = "";
      if (Ques.isMandatory) {
        if (Ques.templateId === 13) {
          Text = SurveyAttributes("allmandatoryText")
            ? SurveyAttributes("allmandatoryText") + "*"
            : "All questions are mandatory*";
          Color = "#eb3434";
        } else {
          Text = "*";
          Color = "#eb3434";
        }
      }
      return {
        text: Text,
        color: Color,
      };
    }

    function showNotCompletedFn(Que) {
      let answersList = [];
      let AnswerListFinal =
        answersList && questions.answersList && questions.answersList.length > 0
          ? questions.answersList
          : [];
      let check = false;
      if (ShowNotAttempted) {
        let getIndex = AnswerListFinal.findIndex(
          (prev) => prev.questionId === Que.id
        );
        if (getIndex !== -1) {
          check =
            AnswerListFinal[getIndex].multiAnswer.length !== 2 ? true : false;
        }
      }

      // console.log("showNotCompletedFn===>",check)
      return check;
    }

    function CompletedCountV1(list) {
      let list2 = [];
      if (list && list.length > 0) {
        list2 = list.filter((prev) => prev.answer !== "");
      }
      // console.log("list2::::", list2);
      if (list2 && list2.length > 0) {
        return list2.length;
      } else {
        return 0;
      }
    }

    let answerCount = CompletedCountV1(answersList);

    let completedMilestone = answerCount;

    function getGroupIndex(QuesId) {
      //console.log("QuesId---------->",QuesId)

      if (GroupQuestionOnlyList && GroupQuestionOnlyList.length > 0) {
        let getIndex = GroupQuestionOnlyList.findIndex(
          (prev) => prev.id === QuesId
        );
        if (getIndex !== -1) {
          //console.log("match---------->",getIndex+1)

          return (getIndex + 1).toString() + ". ";
        } else {
          return "";
        }
      } else {
        return "";
      }
    }

    function functionNameVariable(quesName) {
      return quesName && quesName.toString()
        ? quesName.toString().replace("[variable]", UserRespondantName)
        : quesName;
    }


    function getSecondsToTime(given_seconds) {
      var seconds = parseInt(given_seconds);
      var format =
        (Math.floor(moment.duration(seconds, "seconds").asHours()) < 10
          ? Math.floor(moment.duration(seconds, "seconds").asHours())
          : Math.floor(moment.duration(seconds, "seconds").asHours())) +
        ":" +
        (moment.duration(seconds, "seconds").minutes() < 10
          ? "0" + moment.duration(seconds, "seconds").minutes()
          : moment.duration(seconds, "seconds").minutes()) +
        ":" +
        (moment.duration(seconds, "seconds").seconds() < 10
          ? "0" + moment.duration(seconds, "seconds").seconds()
          : moment.duration(seconds, "seconds").seconds());
      return format;
    }

    function getSecondsToTimeReverse(given_seconds) {
      var seconds = parseInt(given_seconds);
      var format =
        (moment.duration(seconds, "seconds").seconds() < 10
          ? "0" + moment.duration(seconds, "seconds").seconds()
          : moment.duration(seconds, "seconds").seconds()) +
        ":" +
        (moment.duration(seconds, "seconds").minutes() < 10
          ? "0" + moment.duration(seconds, "seconds").minutes()
          : moment.duration(seconds, "seconds").minutes()) +
        ":" +
        (Math.floor(moment.duration(seconds, "seconds").asHours()) < 10
          ? Math.floor(moment.duration(seconds, "seconds").asHours())
          : Math.floor(moment.duration(seconds, "seconds").asHours()));
      return format;
    }
    // console.log("surveyLanguageCode------------>", surveyLanguageCode);

    const GetTextByLanguage = (name, text) => {
      if (surveyLanguageCode && surveyLanguageCode !== "en") {
        let sentence = "";
        if (
          getTranslateElementAllData &&
          getTranslateElementAllData.length > 0
        ) {
          let getIndex = getTranslateElementAllData.findIndex(
            (prev) => prev.name === name
          );
          if (getIndex !== -1) {
            sentence =
              getTranslateElementAllData &&
                getTranslateElementAllData[getIndex] &&
                getTranslateElementAllData[getIndex]["transl"] &&
                getTranslateElementAllData[getIndex]["transl"][surveyLanguageCode]
                ? getTranslateElementAllData[getIndex]["transl"][
                surveyLanguageCode
                ]
                : "";
          }
        }
        console.log("sentence------------>", sentence);
        console.log("surveyLanguageCode------------>", surveyLanguageCode);
        console.log(
          "getTranslateElementAllData------------>",
          getTranslateElementAllData
        );

        return sentence ? sentence : text;
      } else {
        return text;
      }
    };

    const GetDetailsByLanguage = (element, name, text) => {
      if (surveyLanguageCode && surveyLanguageCode !== "en") {
        let sentence =
          element &&
            element["details"] &&
            element["details"]["transl"] &&
            element["details"]["transl"][surveyLanguageCode] &&
            element["details"]["transl"][surveyLanguageCode][name]
            ? element["details"]["transl"][surveyLanguageCode][name]
            : "";
        return sentence ? sentence : text;
      } else {
        return text;
      }
    };

    function EditButtonFn(name, text) {
      return <>{GetTextByLanguage(name, text)}</>;
    }
    function EditDetailsFn(element, name, text, type) {
      if (type === 1) {
        console.log("element-----111--------->", element)
        console.log("name--------111------>", name)
        console.log("text-------111------->", text)
      }
      return <>{GetDetailsByLanguage(element, name, text)}</>;
    }

    function hexToRgbA(hex, opacity) {
      var c;
      if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)) {
        c = hex.substring(1).split("");
        if (c.length == 3) {
          c = [c[0], c[0], c[1], c[1], c[2], c[2]];
        }
        c = "0x" + c.join("");
        return (
          "rgba(" +
          [(c >> 16) & 255, (c >> 8) & 255, c & 255].join(",") +
          "," +
          opacity +
          ")"
        );
      }
      throw hex;
    }

    function getTheme(field, init) {
      if (themeType === 2) {
        if (field === "backgroundImage") {
          return 'url("/img/survey-light-bg.webp")';
        } else if (field === "welcomeImage") {
          return "url('/img/assessment-welcome-large.webp')";
        } else if (field === "text") {
          return "#3D405B";
        } else if (field === "lightblue") {
          return hexToRgbA("#2196F3", "0.12");
        } else if (field === "textblue") {
          return "#2196F3";
        } else if (field === "lightblue") {
          return hexToRgbA("#2196F3", "0.12");
        } else if (field === "hoverActive") {
          return (
            "hover:bg-[" +
            hexToRgbA("#2196F3", "0.12") +
            "] hover:border-[#2196F3] hover:text-[#2196F3] "
          );
        } else if (field === "grayheader") {
          return " bg-[" + hexToRgbA("#3D405B", "0.05") + "] ";
        } else if (field === "textOption") {
          return "border-[#3D405B] text-[#3D405B] ";
        } else {
          return init;
        }
      } else {
        return init;
      }
    }


    let crrEmpDetails = getAssessmenrEmployeeDetailsData;

    let { showWelcomeScreen, instructionPage, showQuestionScreen,
      submitSucces, unattemptList, showRedFlag, ShowSubmitButton,
      showThankyouScreen, alreadySubmitted
    } = this.state;


    function hexToRgbA(hex, opacity) {
      var c;
      if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)) {
        c = hex.substring(1).split("");
        if (c.length == 3) {
          c = [c[0], c[0], c[1], c[1], c[2], c[2]];
        }
        c = "0x" + c.join("");
        return (
          "rgba(" +
          [(c >> 16) & 255, (c >> 8) & 255, c & 255].join(",") +
          "," +
          opacity +
          ")"
        );
      }
      throw hex;
    }
    const assessments =
      Array.isArray(getAssessmentReportByEmpIDData) && getAssessmentReportByEmpIDData.length > 0
        ? getAssessmentReportByEmpIDData
          .slice(0, 5)
          .map((ele, index) => ({
            id: index + 1,
            label: ele?.dimension ?? "",
            color: ele?.colorCode ?? "",
          }))
        : [];


    const getPeriod = () => {
      const hour = moment().hour(); // 0–23

      if (hour >= 5 && hour < 12) return "Morning";
      if (hour >= 12 && hour < 17) return "Afternoon";
      if (hour >= 17 && hour < 21) return "Evening";
      return "Night";
    };

    let userDetails = {
      name: getAssessmenrEmployeeDetailsData?.name ?? "",
      email: getAssessmenrEmployeeDetailsData?.email ?? "",
      period: getPeriod()
    };


    console.log("getCoachUserSurveyListData----->", getCoachUserSurveyListData);


    return (
      <div className="h-dvh">
        {check === 1 || true ? (
          <>
            {surveyLanguageRTL ?
              <SurveyRTL
                handleRadio={this.handleRadio}
                handleGenderChange={this.handleGenderChange}
                handleAgeGroupChange={this.handleAgeGroupChange}
                clicked={clicked}
                viewReport={this.viewReport}
                onLogout={onLogout}
                handleLanguage={this.handleLanguage}
                handleNameInput={this.handleNameInput}
                onUpdateDetails={this.onUpdateDetails}
                goToUpdateDetailsPage={this.goToUpdateDetailsPage}
                goToQuestionPage={this.goToQuestionPage}
                ansNPSInput={this.ansNPSInput}
                nextQues={this.nextQues}
                onMandatoryAttempt={this.onMandatoryAttempt}
                saveAnswers={this.saveAnswers}

                getSecondsToTimeReverse={getSecondsToTimeReverse}
                isSchool={isSchool}
                surveyLanguageRTL={surveyLanguageRTL}
                showNameEditScreen={showNameEditScreen}
                nameFormData={nameFormData}
                errNameForm={errNameForm}
                surveyScreenData={surveyScreenData}
                getAssessmenrEmployeeDetailsData={getAssessmenrEmployeeDetailsData}
                surveyLanguageName={surveyLanguageName}
                LanguageList={LanguageList}
                surveyStatus={surveyStatus}
                showWelcomeScreen={showWelcomeScreen}

                questionsList={questionsList}
                themeType={themeType}
                getTheme={getTheme}
                SurveyAttributes={SurveyAttributes}
                surveyLanguageCode={surveyLanguageCode}
                functionNameVariable={functionNameVariable}
                welcomeTextDislay={welcomeTextDislay}
                instructionPage={instructionPage}
                LabelObj={LabelObj}
                instructionTextDislay={instructionTextDislay}
                afterSubmitData={afterSubmitData}
                showQuestionScreen={showQuestionScreen}
                submitSucces={submitSucces}

                getSecondsToTime={getSecondsToTime}
                CurrQuesIndex={CurrQuesIndex}
                answersList={answersList}
                isMobile={isMobile}
                unattemptList={unattemptList}
                showRedFlag={showRedFlag}
                ShowSubmitButton={ShowSubmitButton}
                submitMandatory={submitMandatory}
                showThankyouScreen={showThankyouScreen}
                showViewReportThankYouButton={showViewReportThankYouButton}
                downloadStatusNo={downloadStatusNo}


                alreadySubmitted={alreadySubmitted}
                bgType={bgType}
                bgColor={bgColor}
                timeCounter={timeCounter}
                getGroupIndex={getGroupIndex}
                hexToRgbA={hexToRgbA}
                bgImage={bgImage}

              />
              :
              <Survey
                handleRadio={this.handleRadio}
                clicked={clicked}
                handleGenderChange={this.handleGenderChange}
                handleAgeGroupChange={this.handleAgeGroupChange}
                viewReport={this.viewReport}
                onLogout={onLogout}
                handleLanguage={this.handleLanguage}
                handleNameInput={this.handleNameInput}
                onUpdateDetails={this.onUpdateDetails}
                goToUpdateDetailsPage={this.goToUpdateDetailsPage}
                goToQuestionPage={this.goToQuestionPage}
                ansNPSInput={this.ansNPSInput}
                nextQues={this.nextQues}
                onMandatoryAttempt={this.onMandatoryAttempt}
                saveAnswers={this.saveAnswers}

                getSecondsToTimeReverse={getSecondsToTimeReverse}
                isSchool={isSchool}
                surveyLanguageRTL={surveyLanguageRTL}
                showNameEditScreen={showNameEditScreen}
                nameFormData={nameFormData}
                errNameForm={errNameForm}
                surveyScreenData={surveyScreenData}
                getAssessmenrEmployeeDetailsData={getAssessmenrEmployeeDetailsData}
                surveyLanguageName={surveyLanguageName}
                LanguageList={LanguageList}
                surveyStatus={surveyStatus}
                showWelcomeScreen={showWelcomeScreen}

                questionsList={questionsList}
                themeType={themeType}
                getTheme={getTheme}
                SurveyAttributes={SurveyAttributes}
                surveyLanguageCode={surveyLanguageCode}
                functionNameVariable={functionNameVariable}
                welcomeTextDislay={welcomeTextDislay}
                instructionPage={instructionPage}
                LabelObj={LabelObj}
                instructionTextDislay={instructionTextDislay}
                afterSubmitData={afterSubmitData}
                showQuestionScreen={showQuestionScreen}
                submitSucces={submitSucces}

                getSecondsToTime={getSecondsToTime}
                CurrQuesIndex={CurrQuesIndex}
                answersList={answersList}
                isMobile={isMobile}
                unattemptList={unattemptList}
                showRedFlag={showRedFlag}
                ShowSubmitButton={ShowSubmitButton}
                submitMandatory={submitMandatory}
                showThankyouScreen={showThankyouScreen}
                showViewReportThankYouButton={showViewReportThankYouButton}
                downloadStatusNo={downloadStatusNo}


                alreadySubmitted={alreadySubmitted}
                bgType={bgType}
                bgColor={bgColor}
                timeCounter={timeCounter}
                getGroupIndex={getGroupIndex}
                hexToRgbA={hexToRgbA}
                bgImage={bgImage}

              />
            }
          </>
        ) : null}

      </div>
    );
  }
}

function mapStateToProps(state) {
  //console.log("state  ", state);
  const { loggingIn } = state.authentication;
  const { questions, users, assessment } = state;
  return {
    loggingIn,
    questions,
    users,
    assessment
  };
}

export default connect(mapStateToProps)(QuestionPublish);